import React, { useContext } from "react";

import { CashoutHistoryModal } from "@features/my-bets/desktop/common/cashout";
import CashoutCounter from "@features/my-bets/desktop/common/cashout/CashoutCounter";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

import { CancelBetSlipPopUp, CashoutConfirmationPopUp } from ".";

export default function Modals() {
	const store = useContext(MyBetsStoreContext);

	return (
		<>
			<CashoutHistoryModal />
			<CancelBetSlipPopUp />
			<CashoutCounter store={store?.cashoutStore} isMini={false} />
			<CashoutConfirmationPopUp />
		</>
	);
}
